import * as React from 'react';

function Twitch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 3H5.535c-.334 0-.646.167-.832.445L3.168 5.748A1.003 1.003 0 003 6.303V18a1 1 0 001 1h3v2a1 1 0 001 1h1.586a.997.997 0 00.707-.293L13 19h3.586a.997.997 0 00.707-.293l4.414-4.414a1 1 0 00.293-.707V4a1 1 0 00-1-1zm0 1v9.586L16.586 18H13a.996.996 0 00-.707.293L9.586 21H8v-2a1 1 0 00-1-1H4V6.303L5.535 4H21z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 15h2.5a.5.5 0 01.5.5v1.793l2.146-2.147A.504.504 0 0112.5 15h3.793L19 12.293V6H7v9zm2.5 4a.5.5 0 01-.5-.5V16H6.5a.5.5 0 01-.5-.5v-10a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v7c0 .133-.053.26-.146.354l-3 3A.504.504 0 0116.5 16h-3.793l-2.853 2.854A.504.504 0 019.5 19z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 13h2V8h-2v5zm1-4v3-3zM10 13h2V8h-2v5zm1-4v3-3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Twitch;
